/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React from 'react';
import { ShimmerTable } from 'react-shimmer-effects';

function IPOrderReportSkeleton() {
    return (
        <div className="w-full table-auto relative pt-[25px]">
            <ShimmerTable row={10} col={11} />
        </div>
    );
}

export default IPOrderReportSkeleton;
